import {createSelector} from 'reselect'
import {getTypesOfWork} from '../../entities/selectors'
import _ from 'underscore'

export default (getTaskPanelState) => {

    const isLoaded = state => getTaskPanelState(state).loaded

    const isLoading = state => getTaskPanelState(state).panelLoading

    const isPanelOpened = state => getTaskPanelState(state).shown

    const getTaskPanelTabKey = state => {
        return getTaskPanelState(state).currentTabKey
    }
    const getLastTaskPanelTabKey = state => getTaskPanelState(state).lastSelectedTabKey

    const isNeedToLoadData = createSelector(
        isLoaded,
        isPanelOpened,
        (loaded, opened) => opened && !loaded
    )

    const getTaskInfo = state => getTaskPanelState(state).taskInfo

    const getTaskPanelErrors = state => getTaskPanelState(state).errors

    const getTaskName = (state) => getTaskInfo(state).name
    const isTaskCompleted = (state) => getTaskInfo(state).completed
    const getCreationTimestamp = (state) => getTaskInfo(state).creationTimestamp
    const getTaskStatusId = (state) => getTaskInfo(state).workflowStatusId
    const getTaskDeadline = (state) => getTaskInfo(state).deadline
    const getTaskBillableTypeId = (state) => getTaskInfo(state).typeOfWorkId
    const getEstimatedTime = (state) => getTaskInfo(state).estimatedTime
    const getSpentTime = (state) => getTaskInfo(state).spentTime
    const getTaskDescription = (state) => getTaskInfo(state).description

    const getBillingType = createSelector(
        getTaskBillableTypeId,
        getTypesOfWork,
        (id, types) => _.pick(types[id], ['id', 'name', 'billable'])
    )
    const getBillableTypeName = (state) => getTaskInfo(state).typeOfWorkName
    const isWorkTypeBillable = (state) => getTaskInfo(state).billable
    const isTaskDataChanged = (state) => getTaskPanelState(state).taskDataChanged

    return {
        isLoaded,
        isLoading,
        isPanelOpened,
        isNeedToLoadData,
        getTaskPanelErrors,
        getTaskPanelTabKey,
        getLastTaskPanelTabKey,

        getTaskInfo,
        isTaskCompleted,
        getCreationTimestamp,
        getTaskStatusId,
        getTaskDeadline,
        getTaskName,
        getEstimatedTime,
        getSpentTime,
        getTaskDescription,
        getBillingType,
        getTaskBillableTypeId,
        getBillableTypeName,
        isWorkTypeBillable,
        isTaskDataChanged,
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/task/selectorsGenerator.js